import React, { useState, useEffect, useCallback } from "react";
import { FaArrowUp } from "react-icons/fa";
import { Scrollindicator } from "./Components/Scrollindicator";
import { Navbar } from "./Components/Navbar/Navbar";
import { Home } from "./Components/Home/Home";
import { About } from "./Components/About/About";
import { Project } from "./Components/Projects/Project";
import { Blog } from "./Components/Blog/Blog";
import { Experience } from "./Components/Experience/Experience";
import { Contact } from "./Components/Contact/Contact";
import GoToTop from "./GoToTop";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  const [btnClass, setBtnClass] = useState(null);

  //Below function and useEffect for bounce btn
  const SettingBtnHei = useCallback(() => {
    let winHei = window.scrollY;
    if (window !== undefined) {
      return winHei > 320
        ? setBtnClass("btn-scroll-to-top  active-btn-scroll-to-top")
        : setBtnClass("btn-scroll-to-top ");
    }
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", SettingBtnHei);
    return () => window.removeEventListener("scroll", SettingBtnHei);
  }, [SettingBtnHei]);

  // this useEffect for animate on Scroll
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <div id="app">
        <Scrollindicator />
        <Navbar />
        <div>
          <div id="home">
            <Home />
          </div>
          <div id="about">
            <About />
          </div>
          <div id="project">
            <Project />
          </div>
          <div id="blog">
            <Blog />
          </div>
          <div id="experience">
            <Experience />
          </div>
          <div id="contact">
            <Contact />
          </div>
        </div>
        {/* Hidden scroll top button */}
        <a href="#app" className={btnClass}>
          <FaArrowUp />
        </a>
      </div>
      <GoToTop />
    </>
  );
}

export default App;
